export { default } from "./ListItemAvatar.js";
export { default as listItemAvatarClasses } from "./listItemAvatarClasses.js";
export * from "./listItemAvatarClasses.js";